import { gql, TypedDocumentNode } from "@apollo/client";

import { GithubEnterpriseIntegration, MutationGithubAppCreateFromManifestArgs } from "types/generated";

export const GENERATE_GITHUB_APP_MANIFEST = gql`
  mutation GenerateGitHubAppManifestInVCS($input: GitHubAppManifestInput!) {
    githubAppGenerateManifest(input: $input) {
      endpoint
      manifest
    }
  }
`;

type CreateGitHubAppFromManifestData = {
  githubAppCreateFromManifest: Pick<GithubEnterpriseIntegration, "apiHost">;
};

export const CREATE_GITHUB_APP_FROM_MANIFEST: TypedDocumentNode<
  CreateGitHubAppFromManifestData,
  MutationGithubAppCreateFromManifestArgs
> = gql`
  mutation CreateGitHubAppFromManifestInVCS(
    $code: String!
    $state: String!
    $customInput: CustomVCSInput
  ) {
    githubAppCreateFromManifest(code: $code, state: $state, customInput: $customInput) {
      apiHost
    }
  }
`;
